'use strict';

import { translate } from '@core/i18n/window-language';
import { TOOLTIP_POSITION } from '@components/TooltipComponent/CONSTANTS';

/**
 * Update tooltip content with translated text
 * @param {HTMLParagraphElement} tooltipDropdownContentText - The tooltip content text element
 * @returns {void}
 */
export const updateTooltipContent = (tooltipDropdownContentText) => {
    tooltipDropdownContentText.innerText = translate('tooltip.defaultHome.unselected');
};

/**
 * Apply tooltip positioning based on position and flex grow
 * @param {HTMLDivElement} tooltipImgsContentContainer - The tooltip container element
 * @param {string} tooltipPosition - The tooltip position
 * @param {number} customFlexGrow - The custom flex grow value
 * @returns {void}
 */
export const applyTooltipPositioning = (
    tooltipImgsContentContainer,
    tooltipPosition,
    customFlexGrow,
) => {
    switch (tooltipPosition) {
        case TOOLTIP_POSITION.BOTTOM_RIGHT:
            tooltipImgsContentContainer.style.right = `${Math.min(customFlexGrow * 0.5, 40)}%`;
            break;
        case TOOLTIP_POSITION.BOTTOM_LEFT:
            tooltipImgsContentContainer.style.left = `${Math.min(customFlexGrow * 0.5, 40)}%`;
            tooltipImgsContentContainer.style.right = 'unset';
            break;
        case TOOLTIP_POSITION.TOP_LEFT:
            tooltipImgsContentContainer.style.right = '45px';
            tooltipImgsContentContainer.style.setProperty('top', '0', 'important');
            break;
        default:
            break;
    }
};
